import { Avatar, Box, IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid";
import { Link } from "react-router-dom";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import DeleteTwoToneIcon from "@mui/icons-material/DeleteTwoTone";
import LaunchTwoToneIcon from "@mui/icons-material/LaunchTwoTone";
import { numericFormatter } from "react-number-format";
import StackedLineChartIcon from "@mui/icons-material/StackedLineChart";
import { ICompanyRevenue } from "../../Interfaces/ICompanyRevenue";

export const columns = (
  editManualRevenue,
  deleteAdditionalRevenue
): GridColDef[] => {
  return [
    {
      field: "testReason",
      headerName: "Test Reason",
      editable: false,
      width: 300,
      sortable: false,
    },
    {
      field: "testCount",
      headerName: "Test Count",
      editable: false,
      width: 200,
      sortable: false,
    },
    {
      field: "avgUnitPricing",
      headerName: "Average Revenue per Test",
      editable: false,
      width: 200,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "totalEstimatedValue",
      headerName: "Total Estimated Value",
      editable: false,
      width: 260,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          prefix: "$",
        });
      },
    },
    {
      field: "percentageContribution",
      headerName: "Percentage contribution to total revenue",
      editable: false,
      width: 300,
      sortable: false,
      valueFormatter(params) {
        return numericFormatter(`${params.value}`, {
          thousandSeparator: true,
          decimalScale: 2,
          fixedDecimalScale: true,
          suffix: "%",
        });
      },
    },
    {
      field: "edit",
      headerName: "Edit",
      editable: false,
      width: 120,
      sortable: false,
      renderCell: (params) => {
        let row = params.row as ICompanyRevenue;
        return (
          <IconButton
            color="primary"
            disabled={row.companyAdditionalRevenueStream == null}
            onClick={() =>
              editManualRevenue(row.companyAdditionalRevenueStream)
            }
          >
            <EditTwoToneIcon />
          </IconButton>
        );
      },
    },
    {
      field: "delete",
      headerName: "Delete",
      editable: false,
      width: 120,
      sortable: false,
      renderCell: (params) => {
        let row = params.row as ICompanyRevenue;
        return (
          <IconButton
            color="primary"
            disabled={row.companyAdditionalRevenueStream == null}
            onClick={() =>
              deleteAdditionalRevenue(row.companyAdditionalRevenueStream)
            }
          >
            <DeleteTwoToneIcon />
          </IconButton>
        );
      },
    },
  ];
};
